import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { rgba } from 'emotion-rgba';

import { colors } from 'src/styles/colors';
import {
  InitialLoadIconsSet,
  NewIconsSet,
  OtherIconsSet
} from 'src/utils/constants/IconsConstants';

import {
  getInitialLoadIcons,
  getNewIcons,
  getOtherIcons,
  ZeeFontBold,
  ZeeFontMedium,
  ZeeFontRegular
} from '../../styles/font';
import { MediaBP as MQ } from '../../styles/mediaQuery';
import { flex } from '../../styles/utils';

export const mainSearchWrapper = (searchFocus: boolean) => css`
  color: ${colors.PrimaryWhiteColor};
  background-color: ${colors.AppBgColor};
  text-align: center;
  margin: auto;
  z-index: 1;
  ${searchFocus
    ? `
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  `
    : ''}

  ${MQ.MediaLg} {
    ${flex('row', 'center', '')};
    flex-grow: 1;
    ${searchFocus
      ? `
        position: relative;
        bottom: 4px;
        right: 0;
        left: 0;
  `
      : ''}
  }
`;

export const searchWrapper = css`
  width: 100%;
`;

export const searchBoxCss = (
  searchFocus: boolean,
  hideMenu: boolean,
  newSearchLandingRevamp: boolean
) => css`
  display: flex;
  border: 1px solid rgba(130, 130, 130, 0.6);
  border-radius: 6px;
  height: 46px;
  margin: 1px 16px 1px 56px;
  position: relative;
  z-index: 2;
  ${searchFocus
    ? `
    border-color: ${colors.PurpleLight};
  `
    : ``}
  ${MQ.MediaLg} {
    width: 318px;
    box-sizing: border-box;
    height: 38px;
    margin: 0;
    ${searchFocus
      ? `
      width: ${hideMenu || newSearchLandingRevamp ? `100%` : `348px`};
      border-color: ${colors.PurpleLight};
      transition: width 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93),
        border-color 0.25s ease-in,
        bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93);
      .searchMic {
        opacity: 1;
        transition: opacity 0.15s ease-in,
          bottom 0.15s cubic-bezier(0.33, 0.04, 0.63, 0.93);
        pointer-events: all;
      }
      `
      : ``};
    margin-top: 2px;
    margin-right: 4px;
  }
  ${MQ.MediaXl} {
    width: 348px;
    ${searchFocus
      ? `{
      width: ${hideMenu ? `100%` : `450px`};
    }`
      : ``}
  }
`;

export const searchInputBox = css`
  height: 25px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  margin: auto;
  padding-left: 40px;
  width: 90%;
  input {
    border: 0;
    outline: 0;
    color: ${colors.PrimaryWhiteColor};
    width: 100%;
    background: transparent;
    padding: 0;
    height: 20px;
    ${ZeeFontRegular(14, 20)};
    ${MQ.MediaLg} {
      ${ZeeFontRegular(12, 20)};
    }
    &:placeholder-shown {
      text-overflow: ellipsis;
    }
  }
  input[type='text']::-ms-clear {
    display: none;
  }
  ${MQ.MediaLg} {
    height: auto;
    input {
      height: auto;
      padding: 9px 0;
    }
  }
`;

export const searchIconCss = css`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  margin-left: 10px;
  ${MQ.MediaLg} {
    top: calc(50% + 1px);
  }
  ${MQ.MediaXl} {
    top: 50%;
  }
`;

export const micOrCloseIcon = css`
  margin-left: auto;
  cursor: pointer;
  ${flex()};
`;

export const micIconCss = css`
  font-size: 1.2rem;
  padding-right: 10px;
  ${getInitialLoadIcons(InitialLoadIconsSet.MIC)}
`;

export const closeIconCss = css`
  font-size: 1.8rem;
  ${getInitialLoadIcons(InitialLoadIconsSet.CLOSE)}
`;

export const searchIcon = css`
  background-color: ${colors.PrimaryWhiteColorAlpha05};
  color: ${colors.PrimaryWhiteColor};
  border-radius: 18px;
  width: 32px;
  height: 32px;
  padding: 6px;
  ${flex()};
  font-size: 18px;
  cursor: pointer;
  ${MQ.MediaMd} {
    margin-right: 4px;
  }
  ${MQ.MediaLg} {
    margin-top: 4px;
    width: 36px;
    height: 36px;
  }
`;

export const searchContainer = css`
  ${flex('column', '', '')};
  flex-grow: 1;
`;

export const backArrowCss = css`
  position: relative;
  cursor: pointer;
  margin-right: auto;
  top: 38px;
  left: 14px;
  font-size: 24px;
  ${getOtherIcons(OtherIconsSet.BACK_ARROW)};
`;

export const dialogWrapper = css`
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: ${rgba(colors.black, 0.6)};
  color: ${colors.PrimaryWhiteColor};
  z-index: 3;
`;

export const dialogContent = css`
  ${flex('column', '', '')};
  background-color: ${colors.DialogContentBackgroundColor};
`;

export const defaultVoiceLanguage = css`
  ${ZeeFontMedium(14, 24)};
  padding-top: 15px;
  color: ${colors.greyText};
  ${MQ.MediaLg} {
    padding: 0 20px 10px 0;
    margin-left: auto;
  }
  ${MQ.MediaXl} {
    bottom: 24px;
    font-size: 16px;
    line-height: 60px;
  }
`;

export const textandiconWrapper = css`
  ${flex('column-reverse', 'center', 'center')};
  ${MQ.MediaLg} {
    padding: 30px 120px;
    ${flex('row', 'flex-start', 'center')};
    position: relative;
  }
`;

export const messageWrapper = css`
  padding-top: 20px;
  ${MQ.MediaLg} {
    padding-top: 0px;
    width: 35%;
    text-align: left;
  }
`;

export const messageText = css`
  ${ZeeFontBold(28, 42)};
  color: ${colors.NewSubscriptionCouponText};
  ${MQ.MediaXl} {
    font-size: 42px;
    line-height: 60px;
  }
`;

export const tryAgainText = (toggleVoiceTurnedOffDetails = false) => css`
  ${ZeeFontMedium(16, 22)};
  cursor: pointer;
  color: ${toggleVoiceTurnedOffDetails
    ? colors.AccentInfoPopupDescriptionMobileColor
    : colors.PurpleLight};
  margin-left: 5px;
  ${MQ.MediaXl} {
    font-size: 24px;
    line-height: 36px;
  }
`;

export const detailsInfo = css`
  ${ZeeFontMedium(14, 24)};
  margin-top: 24px;
  span {
    a {
      cursor: pointer;
      color: ${colors.PurpleLight};
    }
  }
`;

export const outerCircle = css`
  width: 110px;
  height: 110px;
  padding: 10px;
  border-radius: 50%;
  background-color: ${colors.greyText};
  ${MQ.MediaXl} {
    width: 120px;
    height: 120px;
  }
`;

export const innerCircle = css`
  width: 90px;
  height: 90px;
  border-radius: 50%;
  ${flex()};
  background-color: ${colors.Grey88};
  ${MQ.MediaXl} {
    width: 100px;
    height: 100px;
  }
`;

export const voiceMic = css`
  font-size: 3rem;
  color: ${colors.ComboPopupSubtitleGray};
  ${MQ.MediaXl} {
    font-size: 4rem;
  }
  ${getOtherIcons(OtherIconsSet.MIC)};
`;

export const listeningIcon = css`
  width: 160px;
  height: 160px;
  background: url('/webapp-assets/images/listening.gif') no-repeat center;
`;

export const errorIcon = css`
  ${ZeeFontBold(25, 20)};
  width: 35px;
  height: 35px;
  padding: 5px;
  border-radius: 50px;
  background-color: ${colors.ErrorIconBackgroundColor};
  border: 2px solid ${colors.AccentPromoCodeFailureColor};
  color: ${colors.ErrorIconColor};
  margin-left: -32px;
  ${MQ.MediaXl} {
    width: 35px;
    height: 35px;
  }
`;

export const MainSearchWrapper = styled.div`
  ${mainSearchWrapper}
`;

export const closeMicPopup = css`
  cursor: pointer;
  margin-left: auto;
  padding: 5px 20px 0 0;
  font-size: 2rem;
  ${getInitialLoadIcons(InitialLoadIconsSet.CLOSE)};
`;
export const circleCss = css`
  display: flex;
  ${MQ.MediaLg} {
    position: absolute;
    left: 45%;
  }
`;

export const searchOverly = css`
  height: 100vh;
  position: fixed;
  top: 79px;
  left: 0;
  width: 100vw;
  background: ${colors.PrimaryBlackColorAlpha60};
`;

export const SearchInputBox = styled.div`
  ${searchInputBox}
`;
export const SearchWrapper = styled.div`
  ${searchWrapper}
`;
export const SearchIconCss = styled.div`
  ${getNewIcons(NewIconsSet.SEARCH)};
  font-size: 22px;
  ${MQ.MediaXl} {
    font-size: 24px;
  }
  ${searchIconCss};
`;
export const MicOrCloseIcon = styled.div`
  ${micOrCloseIcon}
`;

export const SearchIcon = styled.div`
  ${searchIcon};
`;

export const DialogWrapper = styled.div`
  ${dialogWrapper};
`;

export const DialogContent = styled.div`
  ${dialogContent};
`;

export const SearchContainer = styled.div`
  ${searchContainer};
`;

export const DefaultVoiceLanguage = styled.div`
  ${defaultVoiceLanguage};
`;

export const TextandiconWrapper = styled.div`
  ${textandiconWrapper};
`;

export const MessageWrapper = styled.div`
  ${messageWrapper};
`;

export const MessageText = styled.div`
  ${messageText};
`;

export const DetailsInfo = styled.div`
  ${detailsInfo};
`;
export const OuterCircle = styled.div`
  ${outerCircle};
`;
export const InnerCircle = styled.div`
  ${innerCircle};
`;
export const VoiceMic = styled.div`
  ${voiceMic};
`;
export const ErrorIcon = styled.div`
  ${errorIcon};
`;
export const ListeningIcon = styled.div`
  ${listeningIcon};
`;
export const CloseMicPopup = styled.div`
  ${closeMicPopup};
`;
export const CircleCss = styled.div`
  ${circleCss};
`;
